// 加载文档
/**
 * https://git.woa.com/docx-online/docx-online/blob/master/library/collab/core/base/error/code/importer_code.h
 */
export var ImporterErrorCode;
(function (ImporterErrorCode) {
    ImporterErrorCode[ImporterErrorCode["kSuccess"] = 0] = "kSuccess";
    ImporterErrorCode[ImporterErrorCode["kUnknownDocsType"] = 14001] = "kUnknownDocsType";
    ImporterErrorCode[ImporterErrorCode["kFileNotExist"] = 14002] = "kFileNotExist";
    ImporterErrorCode[ImporterErrorCode["kInvalidFilesystem"] = 14003] = "kInvalidFilesystem";
    ImporterErrorCode[ImporterErrorCode["kFilesystemEmitError"] = 14004] = "kFilesystemEmitError";
    ImporterErrorCode[ImporterErrorCode["kTreewalkerEmitError"] = 14005] = "kTreewalkerEmitError";
    ImporterErrorCode[ImporterErrorCode["kInvalidRefResolver"] = 14006] = "kInvalidRefResolver";
    ImporterErrorCode[ImporterErrorCode["kInvalidPackageContext"] = 14007] = "kInvalidPackageContext";
    ImporterErrorCode[ImporterErrorCode["kInvalidPartContext"] = 14008] = "kInvalidPartContext";
    ImporterErrorCode[ImporterErrorCode["kInvalidPackageDescriptor"] = 14009] = "kInvalidPackageDescriptor";
    ImporterErrorCode[ImporterErrorCode["kInvalidPartDescriptor"] = 14010] = "kInvalidPartDescriptor";
    ImporterErrorCode[ImporterErrorCode["kInvalidPackageStrategy"] = 14011] = "kInvalidPackageStrategy";
    ImporterErrorCode[ImporterErrorCode["kInvalidPartStrategy"] = 14012] = "kInvalidPartStrategy";
    ImporterErrorCode[ImporterErrorCode["kInvalidAssetPart"] = 14013] = "kInvalidAssetPart";
    ImporterErrorCode[ImporterErrorCode["kPasswordRequired"] = 14014] = "kPasswordRequired";
    ImporterErrorCode[ImporterErrorCode["kInvalidPassword"] = 14015] = "kInvalidPassword";
    ImporterErrorCode[ImporterErrorCode["kInvalidEncryptionContext"] = 14016] = "kInvalidEncryptionContext";
    ImporterErrorCode[ImporterErrorCode["kInvalidImportConfig"] = 14017] = "kInvalidImportConfig";
    ImporterErrorCode[ImporterErrorCode["kInvalidNamespaceWhenSeekSectpr"] = 14018] = "kInvalidNamespaceWhenSeekSectpr";
    ImporterErrorCode[ImporterErrorCode["kImportCancel"] = 14019] = "kImportCancel";
    ImporterErrorCode[ImporterErrorCode["kNotSupported"] = 14020] = "kNotSupported";
    ImporterErrorCode[ImporterErrorCode["kInvalidImportCache"] = 14021] = "kInvalidImportCache";
    ImporterErrorCode[ImporterErrorCode["kInvalidSheetRef"] = 14022] = "kInvalidSheetRef";
    ImporterErrorCode[ImporterErrorCode["kInvalidDrawRef"] = 14023] = "kInvalidDrawRef";
    ImporterErrorCode[ImporterErrorCode["kInvalidChartRef"] = 14024] = "kInvalidChartRef";
    ImporterErrorCode[ImporterErrorCode["kLostRequiredData"] = 14025] = "kLostRequiredData";
    ImporterErrorCode[ImporterErrorCode["kInvalidPivotTableRef"] = 14026] = "kInvalidPivotTableRef";
    ImporterErrorCode[ImporterErrorCode["kEmptySheetCell"] = 14027] = "kEmptySheetCell";
    ImporterErrorCode[ImporterErrorCode["kInvalidSheetId"] = 14028] = "kInvalidSheetId";
    ImporterErrorCode[ImporterErrorCode["kSheetDimensionLimited"] = 14029] = "kSheetDimensionLimited";
    ImporterErrorCode[ImporterErrorCode["kPresentationPrNotEnough"] = 14030] = "kPresentationPrNotEnough";
    ImporterErrorCode[ImporterErrorCode["kSlideMasterNotFound"] = 14031] = "kSlideMasterNotFound";
    ImporterErrorCode[ImporterErrorCode["kSlideChunkPageEmptyError"] = 1077] = "kSlideChunkPageEmptyError";
})(ImporterErrorCode || (ImporterErrorCode = {}));
export var DesktopErrorCode;
(function (DesktopErrorCode) {
    /**
     * 未知错误
     */
    DesktopErrorCode[DesktopErrorCode["ErrorUnknown"] = 23000] = "ErrorUnknown";
    /**
     * 文档正在使用中，暂时无法打开
     */
    DesktopErrorCode[DesktopErrorCode["ErrorBusy"] = 23001] = "ErrorBusy";
    /**
     * 文档路径无效或无读取权限，暂时无法打开
     */
    DesktopErrorCode[DesktopErrorCode["ErrorNotEntity"] = 23002] = "ErrorNotEntity";
    /**
     * 文档无权限，暂时无法打开或写入
     */
    DesktopErrorCode[DesktopErrorCode["ErrorPermittion"] = 23003] = "ErrorPermittion";
    /**
     * 转换工具安装出错
     */
    DesktopErrorCode[DesktopErrorCode["ErrorConverterInstall"] = 23090] = "ErrorConverterInstall";
})(DesktopErrorCode || (DesktopErrorCode = {}));
/**
 * TODO: 待客户端补充
 * 移动客户端通用错误
 */
export var MobileErrorCode;
(function (MobileErrorCode) {
    /**
     * 未知错误
     */
    MobileErrorCode[MobileErrorCode["ErrorUnknown"] = 23000] = "ErrorUnknown";
    /**
     * 域名不支持
     */
    MobileErrorCode[MobileErrorCode["DomainError"] = 23001] = "DomainError";
    /**
     * 参数有误
     */
    MobileErrorCode[MobileErrorCode["RequestParseError"] = 23002] = "RequestParseError";
    /**
     * IO引擎导入/导出报错
     */
    MobileErrorCode[MobileErrorCode["IOResultParseError"] = 23003] = "IOResultParseError";
    /**
     * 文件不存在
     */
    MobileErrorCode[MobileErrorCode["FileNoExist"] = 23004] = "FileNoExist";
    /**
     * 图片上传失败
     */
    MobileErrorCode[MobileErrorCode["ImageUploadError"] = 23005] = "ImageUploadError";
    /**
     * 图片下载失败
     */
    MobileErrorCode[MobileErrorCode["ImageDownloadError"] = 23006] = "ImageDownloadError";
    /**
     * 文件读取失败
     */
    MobileErrorCode[MobileErrorCode["FileReadFailed"] = 23007] = "FileReadFailed";
    /**
     * 接口未实现
     */
    MobileErrorCode[MobileErrorCode["NotImplemented"] = 23999] = "NotImplemented";
})(MobileErrorCode || (MobileErrorCode = {}));
/**
 * https://git.woa.com/docx-online/docx-online/blob/master/library/collab/core/base/error/code/exporter_code.h
 */
export var ExporterErrorCode;
(function (ExporterErrorCode) {
    ExporterErrorCode[ExporterErrorCode["kUnknownDocsType"] = 15001] = "kUnknownDocsType";
    ExporterErrorCode[ExporterErrorCode["kInvalidFileHandle"] = 15002] = "kInvalidFileHandle";
    ExporterErrorCode[ExporterErrorCode["kRequiredVisitor"] = 15003] = "kRequiredVisitor";
    ExporterErrorCode[ExporterErrorCode["kInvalidPartStrategy"] = 15004] = "kInvalidPartStrategy";
    ExporterErrorCode[ExporterErrorCode["kEmptyDataContent"] = 15005] = "kEmptyDataContent";
    ExporterErrorCode[ExporterErrorCode["kLostPartVisitor"] = 15006] = "kLostPartVisitor";
    ExporterErrorCode[ExporterErrorCode["kExportPBToXFailed"] = 15007] = "kExportPBToXFailed";
    ExporterErrorCode[ExporterErrorCode["kEmbedFontFileNotExist"] = 15008] = "kEmbedFontFileNotExist";
    ExporterErrorCode[ExporterErrorCode["kEmbedFontOriginFileOpenError"] = 15009] = "kEmbedFontOriginFileOpenError";
    ExporterErrorCode[ExporterErrorCode["kEmbedFontDstFileOpenError"] = 15010] = "kEmbedFontDstFileOpenError";
    ExporterErrorCode[ExporterErrorCode["kInvalidOOXMLNode"] = 15011] = "kInvalidOOXMLNode";
    ExporterErrorCode[ExporterErrorCode["kEncryptFileFailed"] = 15012] = "kEncryptFileFailed";
    ExporterErrorCode[ExporterErrorCode["kExportCancel"] = 15013] = "kExportCancel";
    ExporterErrorCode[ExporterErrorCode["kInvalidSheetModel"] = 15014] = "kInvalidSheetModel";
    ExporterErrorCode[ExporterErrorCode["kInvalidWorksheetId"] = 15015] = "kInvalidWorksheetId";
    ExporterErrorCode[ExporterErrorCode["kInvalidWorksheetChartData"] = 15016] = "kInvalidWorksheetChartData";
    ExporterErrorCode[ExporterErrorCode["kInvalidPivotTable"] = 15017] = "kInvalidPivotTable";
    ExporterErrorCode[ExporterErrorCode["kInvalidPivotCacheDefinitions"] = 15018] = "kInvalidPivotCacheDefinitions";
    ExporterErrorCode[ExporterErrorCode["kInvalidPivotCacheRecords"] = 15019] = "kInvalidPivotCacheRecords";
    ExporterErrorCode[ExporterErrorCode["kInvalidSheetPivotTable"] = 15020] = "kInvalidSheetPivotTable";
    ExporterErrorCode[ExporterErrorCode["kInvalidSheetSharedStringCache"] = 15021] = "kInvalidSheetSharedStringCache";
    ExporterErrorCode[ExporterErrorCode["kInvalidSheetFrozenProperty"] = 15022] = "kInvalidSheetFrozenProperty";
    ExporterErrorCode[ExporterErrorCode["kInvalidSheetChart"] = 15023] = "kInvalidSheetChart";
    ExporterErrorCode[ExporterErrorCode["kInvalidSheetComment"] = 15024] = "kInvalidSheetComment";
    ExporterErrorCode[ExporterErrorCode["kAllWorksheetAreHidden"] = 15025] = "kAllWorksheetAreHidden";
    ExporterErrorCode[ExporterErrorCode["kInvalidSlideModel"] = 15026] = "kInvalidSlideModel";
    ExporterErrorCode[ExporterErrorCode["kEmptySlideViewPr"] = 15027] = "kEmptySlideViewPr";
    ExporterErrorCode[ExporterErrorCode["kEmptyTableStyleList"] = 15028] = "kEmptyTableStyleList";
    ExporterErrorCode[ExporterErrorCode["kEmptyPresPros"] = 15029] = "kEmptyPresPros";
    ExporterErrorCode[ExporterErrorCode["kInvalidSlideId"] = 15030] = "kInvalidSlideId";
    ExporterErrorCode[ExporterErrorCode["kInvalidSlideMasterId"] = 15031] = "kInvalidSlideMasterId";
    ExporterErrorCode[ExporterErrorCode["kInvalidNotesSlideId"] = 15032] = "kInvalidNotesSlideId";
    ExporterErrorCode[ExporterErrorCode["kNotesMasterNotFound"] = 15033] = "kNotesMasterNotFound";
    ExporterErrorCode[ExporterErrorCode["kInvalidSlideSection"] = 15034] = "kInvalidSlideSection";
    ExporterErrorCode[ExporterErrorCode["kSlideTableNotFound"] = 15035] = "kSlideTableNotFound";
})(ExporterErrorCode || (ExporterErrorCode = {}));
export const MobileImportErrorCode = Object.assign(Object.assign({}, ImporterErrorCode), MobileErrorCode);
export const MobileExportErrorCode = Object.assign(Object.assign({}, ExporterErrorCode), MobileErrorCode);
export var DocType;
(function (DocType) {
    DocType[DocType["Word"] = 0] = "Word";
    DocType[DocType["Excel"] = 1] = "Excel";
    DocType[DocType["Form"] = 2] = "Form";
    DocType[DocType["Slide"] = 4] = "Slide";
    DocType[DocType["PDF"] = 6] = "PDF";
    DocType[DocType["MIND"] = 90] = "MIND";
    DocType[DocType["FLOWCHART"] = 91] = "FLOWCHART";
})(DocType || (DocType = {}));
export var DocxReportAction;
(function (DocxReportAction) {
    /**
     * 数据加载完成
     */
    DocxReportAction["FINISH_LOAD"] = "FINISH_LOAD";
    /**
     * 渲染完成
     */
    DocxReportAction["FINISH_DISPLAY"] = "FINISH_DISPLAY";
    /**
     * 开始导出数据
     */
    DocxReportAction["BEGIN_DUMP"] = "BEGIN_DUMP";
    /**
     * 移动端统一性能上报
     */
    DocxReportAction["MOBILE_PERFERMANCE"] = "MOBILE_PERFERMANCE";
})(DocxReportAction || (DocxReportAction = {}));
/**
 * 移动端性能上报时机点
 */
export var OpenPerformancePoint;
(function (OpenPerformancePoint) {
    OpenPerformancePoint["CAN_VIEW"] = "can_view";
    OpenPerformancePoint["CAN_INTERACT"] = "can_interact";
    OpenPerformancePoint["CAN_EDIT"] = "can_edit";
})(OpenPerformancePoint || (OpenPerformancePoint = {}));
export var DocxLoadInternalEvent;
(function (DocxLoadInternalEvent) {
    /**
     * 转换完成，该消息被 buffer 之后由 piped channel 进行消费，达到缓存数据目的
     */
    DocxLoadInternalEvent["Complete"] = "complete";
    /**
     * 读取缓存
     */
    DocxLoadInternalEvent["ReadCache"] = "read-cache";
})(DocxLoadInternalEvent || (DocxLoadInternalEvent = {}));
export var DocxLoadEvent;
(function (DocxLoadEvent) {
    /**
     * 向 web 发送数据
     */
    DocxLoadEvent["Data"] = "data";
    /**
     * 进程被杀死，可能是用户刷新了页面
     */
    DocxLoadEvent["Abort"] = "abort";
    /**
     * 转换工具抛错
     */
    DocxLoadEvent["ConverterError"] = "converter-error";
    /**
     * 用户输入密码
     */
    DocxLoadEvent["ContinueWithPassword"] = "continue-with-password";
    /**
     * 桌面端错误，包括转换工具下载失败，解析转换工具输出结果失败等
     */
    DocxLoadEvent["DesktopError"] = "desktop-error";
    /**
     * 移动端错误，包括导入导出工具和移动端基础错误
     */
    DocxLoadEvent["MobileError"] = "mobile-error";
})(DocxLoadEvent || (DocxLoadEvent = {}));
export var DataType;
(function (DataType) {
    DataType[DataType["SlideFile"] = 0] = "SlideFile";
})(DataType || (DataType = {}));
export var DocxChunkLoadEvent;
(function (DocxChunkLoadEvent) {
    /**
     * 首帧数据
     */
    DocxChunkLoadEvent["Head"] = "head";
    /**
     * 分片数据推送
     */
    DocxChunkLoadEvent["Chunk"] = "chunk";
    /**
     * 分片加载正常结束，没有错误
     */
    DocxChunkLoadEvent["End"] = "end";
    /**
     * 进程被杀死，可能是用户刷新了页面
     */
    DocxChunkLoadEvent["Abort"] = "abort";
    /**
     * 转换过程中出现异常，转换终止
     */
    DocxChunkLoadEvent["Error"] = "error";
    /**
     * 用户输入密码
     */
    DocxChunkLoadEvent["ContinueWithPassword"] = "continue-with-password";
})(DocxChunkLoadEvent || (DocxChunkLoadEvent = {}));
export var DocxSaveEvent;
(function (DocxSaveEvent) {
    DocxSaveEvent["JSONSaved"] = "json-saved";
    DocxSaveEvent["DocumentSaved"] = "document-saved";
    /**
     * 用户取消保存
     */
    DocxSaveEvent["Cancel"] = "cancel";
    /**
     * 进程被杀死，可能是用户强制退出 App
     */
    DocxSaveEvent["Abort"] = "abort";
    /**
     * https://git.woa.com/docx-online/docx-online/blob/master/library/collab/core/base/error/code/exporter_code.h
     */
    DocxSaveEvent["ConverterError"] = "converter-error";
    /**
     * 桌面端错误，包括转换工具下载失败，解析转换工具输出结果失败等
     */
    DocxSaveEvent["DesktopError"] = "desktop-error";
    /**
     * 移动端错误，包括导入导出工具和移动端基础错误
     */
    DocxSaveEvent["MobileError"] = "mobile-error";
})(DocxSaveEvent || (DocxSaveEvent = {}));
// 转换工具 & 缓存，仅桌面端关心
export const DATA_FILE = 'data.json';
//# sourceMappingURL=mega-docx-service.protocol.js.map